import React, { useEffect, useState, useRef } from "react";

import FILTVOffAir from "./FILTVOffAir";
import FILTVTuningIn from "./FILTVTuningIn";
import { MIN_TUNING_IN_MS } from "./filtvConstants";

function withMuteParam(url, muted) {
    if (!url) return url;
    if (/[?&]mute=/.test(url)) {
        return url.replace(/([?&]mute=)(0|1)/, `$1${muted ? 1 : 0}`);
    }
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}mute=${muted ? 1 : 0}`;
}

const UnmuteButton = ({ onClick }) => (
    <button
        onClick={onClick}
        className="absolute bottom-3 right-3 z-20 flex items-center gap-1.5 rounded-full bg-black/70 backdrop-blur w-fit px-3 py-1.5 text-xs font-semibold text-white border border-zinc-600 hover:border-purple-400 transition-colors"
    >
        🔇 Tap to unmute
    </button>
);

const FILTVPlayer = ({ ad, channel, loading }) => {
    const [minDelayPassed, setMinDelayPassed] = useState(false);
    const [muted, setMuted] = useState(true);
    const videoRef = useRef(null);

    useEffect(() => {
        setMinDelayPassed(false);
        setMuted(true); // new channel = autoplay requires muted again
        const timer = setTimeout(() => setMinDelayPassed(true), MIN_TUNING_IN_MS);
        return () => clearTimeout(timer);
    }, [channel?.lcn]);

    const noAdYet = !ad || !ad.videoLink;
    const stillTuning = loading || (noAdYet && !minDelayPassed);

    if (stillTuning) {
        return <FILTVTuningIn channel={channel} />;
    }

    if (noAdYet) {
        return <FILTVOffAir channel={channel} />;
    }

    if (ad.videoType === "mp4") {
        return (
            <div className="relative">
                <video
                    ref={videoRef}
                    className="w-full aspect-video bg-black"
                    controls
                    autoPlay
                    muted={muted}
                    playsInline
                >
                    <source src={ad.videoLink} type="video/mp4" />
                </video>
                {muted && (
                    <UnmuteButton
                        onClick={() => {
                            setMuted(false);
                            if (videoRef.current) videoRef.current.muted = false;
                        }}
                    />
                )}
            </div>
        );
    }

    // default: youtube
    return (
        <div className="relative">
            <iframe
                key={muted ? "muted" : "unmuted"}
                className="w-full aspect-video bg-black"
                src={`${withMuteParam(ad.videoLink, muted)}&playsinline=1`}
                allow="autoplay; encrypted-media"
                allowFullScreen
                title="FiLTV Player"
            />
            {muted && <UnmuteButton onClick={() => setMuted(false)} />}
        </div>
    );
};

export default FILTVPlayer;
